module.exports = __webpack_public_path__ + "img/ic-devices.19bb5b0c.svg";